<template>
  <v-container>
    <v-flex md12 sm12 class="my-4">
              <h3>INTERBANK / GESTIONES</h3>
    </v-flex>
    <vue-dropzone
      v-if="form.attachment == ''"
      id="drop1"
      ref="dropzone"
      v-on:vdropzone-success="logoUploaded"
      :options="dropOptions"
      class="mb-3"
    ></vue-dropzone>
    <div
      style="text-align: center; position: relative; width: 50%; margin: 0 auto"
      class="mb-3"
      v-else
    >
      <v-btn absolute right top icon flat color="error" @click="removePicture">
        <v-icon>delete</v-icon>
      </v-btn>
      <img :src="form.attachment" style="width: 80%" />
    </div>
    <v-card flat style="border-radius: 0">
      <v-card-text class="px-3">
        <h5 style="display: inline-block">Nueva Gestión</h5>
      </v-card-text>
      <v-card-text>
        <v-layout row wrap>
          <v-flex md12 sm12 class="pr-2">
            <v-text-field label="ID del agente" v-model="form.agent_id" v-on:blur="retrieveData()"></v-text-field>
          </v-flex>

          <!-- ¡Hola Gregori! Aqui van los datos del agente, aprovecha el loader para que se vea bonito jejeje! pilla que puse un v-if agent_data: null, si quieres pones allí lo que te devuelve la api y renderizas. -->

          <v-layout row wrap v-if="agent_data != null">
            <div
              v-if="loader.agentData"
              style="position: absolute; background: rgba( 255,255,255,0.7 ); width: 100%; height: 100%;"
            >
              <v-progress-circular
                indeterminate
                color="primary"
                :size="50"
                style="position: absolute; top: 50%; left: 50%; transform: translate( -50%, -50% );"
              ></v-progress-circular>
            </div>
            <v-flex md12 sm12 class="pr-2">
              <h5>Datos del Agente</h5>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Nombre" v-model="agent_datas.name" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Dirección" v-model="agent_datas.direction" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Distrito" v-model="agent_datas.district" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Provincia" v-model="agent_datas.province" disabled></v-text-field>
            </v-flex>
          </v-layout>
          <!-- Aqui terminan los datos del agente -->

          <v-flex md4 sm12 class="pr-2">
            <v-select
              label="Tipo de gestión"
              v-model="form.type"
              :items="basic.type"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <!-- Fecha de solicitud -->
          <v-menu
            v-model="pickers.date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="formatDate"
                label="Fecha de Emisión"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker locale="es-es" v-model="form.date" @input="pickers.date = false"></v-date-picker>
          </v-menu>

          <!-- Fecha de expedición -->
          <v-menu
            v-model="pickers.exp_date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="formatExpDate"
                label="Fecha de vencimiento"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker locale="es-es" v-model="form.exp_date" @input="pickers.exp_date = false"></v-date-picker>
          </v-menu>

          <v-flex md6 sm12 class="pr-2">
            <v-text-field label="Tipo de letrero" hint="Solo si es un letrero" persistent-hint></v-text-field>
          </v-flex>
          <v-flex md6 sm12 class="pr-2">
            <v-text-field label="Número del Autorización" v-model="form.num"></v-text-field>
          </v-flex>

          <v-flex md6 sm12 class="pr-2">
            <v-text-field label="Número de Serie" v-model="form.serie"></v-text-field>
          </v-flex>
          <v-flex md4 sm12 class="pr-2">
            <v-select
              v-model="form.status"
              label="Estado actual"
              :items="basic.status"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex md8 sm12>
            <v-text-field label="Observaciones" v-model="form.observations"></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close()" :disabled="loader.saveBtn" color="error">Cerrar</v-btn>
        <v-btn @click="save()" :loading="loader.saveBtn" color="primary">Guardar</v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" bottom right :timeout="2000">
      <v-icon>{{ snackbar.icon }}</v-icon>
      &nbsp;
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.show = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import axios from "@/api/axios/config";
import base_url from "@/api/axios/base_url";
import vueDropzone from "vue2-dropzone";

export default {
  components: {
    vueDropzone
  },
  data() {
    return {
      agent_data: null,
      agent_datas: [],
      loader: {
        agentData: false,
        saveBtn: false
      },
      snackbar: {
        icon: "",
        text: "",
        color: "",
        show: false
      },
      pickers: {
        date: false,
        exp_date: false
      },
      form: {
        agent_id: "",
        num: "",
        serie: "",
        sign_type: "",
        type: "",
        date: "",
        attachment: "",
        exp_date: "",
        status: "",
        observations: ""
      },
      basic: {
        status: [
          { value: "PENDIENTE", text: "Pendiente" },
          { value: "EN CURSO", text: "En curso" },
          { value: "COMPLETADO", text: "Completado" },
          { value: "RECHAZADO", text: "Rechazado" }
        ],
        type: [
          { value: "DECLARACION JURADA", text: "Declaración jurada" },
          { value: "LICENCIA", text: "Licencia" },
          { value: "AUTORIZACIÓN DE ANUNCIO", text: "Autorización de Anuncio" },
          { value: "NORMA LEGAL", text: "Norma Legal" }
        ]
      },
      dropOptions: {
        headers: { Authorization: localStorage.getItem("token") },
        url: base_url.serverURI + "nueva-data/attachment",
        maxFilesize: 50, // MB
        maxFiles: 1, //5,
        thumbnailWidth: null, // px
        thumbnailHeight: 240,
        addRemoveLinks: false
      }
    };
  },
  computed: {
    formatDate() {
      return this.form.date ? moment(this.form.date).format("DD/MM/YYYY") : "";
    },
    formatExpDate() {
      return this.form.exp_date
        ? moment(this.form.exp_date).format("DD/MM/YYYY")
        : "";
    }
  },
  methods: {
    close() {
      this.$router.push("/data/historial");
    },
    removePicture() {
      this.$confirm("¿Realmente quieres eliminar este elemento?").then(res => {
        if (res) {
          this.form.attachment = "";
        }
      });
    },
    logoUploaded(file, response) {
      if (response.status) {
        this.form.attachment = response.path;
        this.snackbar = {
          icon: "check_circle",
          text: "¡Archivo cargado con éxito!",
          color: "success",
          show: true
        };
      } else {
        this.snackbar = {
          icon: "error",
          text: response.error,
          color: "error",
          show: true
        };
      }
    },
    retrieveData() {
      this.agent_data = true;
      this.agentData = true;
      axios
        .get("agents/" + this.form.agent_id)
        .then(response => {
          if (response.data.status) {
            this.agent_datas = response.data.items;
          }
        })
        .catch(err => {
          this.snackbar = {
            icon: "error",
            text: err,
            color: "success",
            show: true
          };
        })
        .finally(() => {
          this.loader.disableInput = false;
          this.loader.saveBtn = false;
        });
    },
    save() {
      this.loader.saveBtn = true;
      axios
        .post("nueva-data/create", this.form)
        .then(response => {
          if (response.status) {
            this.snackbar = {
              icon: "check_circle",
              text: "¡Nuevo permiso agregado!",
              color: "success",
              show: true
            };
            setTimeout(() => {
              this.close();
            }, 2000);
          } else {
            this.snackbar = {
              icon: "error",
              text: "Ocurrió un error en el servidor",
              color: "success",
              show: true
            };
            this.loader.saveBtn = false;
          }
        })
        .catch(err => {
          this.snackbar = {
            icon: "error",
            text: err,
            color: "success",
            show: true
          };
          this.loader.saveBtn = false;
        });
    }
  }
};
</script>

<style scoped>
.dragzone {
  border: dashed 2px #bbb;
  border-radius: 10px;
}
.locate-middle {
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  color: #bbb;
}
#drop1 {
  cursor: pointer;
  height: auto;
  padding: 40px;
  border: dashed 2px #bbb;
  color: #bbb;
  font-size: 17px;
  background: transparent;
  border-radius: 10px;
}
#drop1 .dz-preview {
  width: 40%;
}

.dz-image,
.dz-details {
  border-radius: 5px !important;
}
</style>